import React, { Component, type ReactNode } from "react";
import { Col, Row } from "reactstrap";
import Popups from "src/app/popups/Popups";
import "./NonAuthenticated.css";

export interface INonAuthenticatedProps {
  className?: string;
}

export default class NonAuthenticated extends Component<INonAuthenticatedProps> {
  public render(): ReactNode {
    const { className = "", children } = this.props;
    return (
      <Row className={`non-authenticated ${className}`}>
        <Col sm={12} md={8} lg={4}>
          {children}

          <Popups />
        </Col>
      </Row>
    );
  }
}
